module.exports = __webpack_public_path__ + "img/227.ada66fe4.jpg";